import { createContext, ReactNode, useContext, useMemo } from 'react'
import { BehaviorSubject } from 'rxjs'

import { useGetSubject } from '@/utils/hooks'
import { StoredStringSubject } from '@/utils/storage'

export const authToken = new StoredStringSubject('auth-token', '')

export interface AuthContextValue {
	authToken: BehaviorSubject<string>
}

const AuthContext = createContext<AuthContextValue>(undefined as any)
export const useAuth = () => {
	const value = useContext(AuthContext)
	if (!value) {
		throw new Error('useAuth must be used within a AuthProvider')
	}
	const authToken = useGetSubject(value.authToken)
	return {
		authToken,
		isAuthenticated: !!authToken
	}
}

export const AuthProvider = ({ children }: { children: ReactNode }) => {
	const value = useMemo<AuthContextValue>(() => ({ authToken }), [])
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
